import { ApiResponse } from "interfaces/models/api";
import { BlackboardFormat } from "interfaces/models/blackboard";
import { axiosECS } from "services/baseAxios";

const path = `/v1/blackboards/formats`;

export const getBlackboardFormat = async (
  inspectionTypeId: string,
  shouldCache?: boolean
): Promise<ApiResponse<BlackboardFormat>> => {
  return axiosECS.get(`${path}/${inspectionTypeId}`, {
    params: {
      shouldCache,
    },
  });
};

export const updateBlackboardFormat = async (body: any) => {
  return axiosECS.patch(path, body);
};
